import styles from "./Footer.module.css";
import {
  FaGithub,
  FaInstagram,
  FaLinkedin,
  FaTelegramPlane,
} from "react-icons/fa";

const Footer = () => {
  return (
    <div id="myContacts" className={styles.contactMe}>
      <h2 className={styles.title}>Contact me:</h2>
      <p className={styles.email}>
        Email:{" "}
        <a href="mailto:chasov90@gmail.com" className={styles.emailLink}>
          chasov90@gmail.com
        </a>
      </p>

      <div className={styles.socialsWrap}>
        <p className={styles.socialTitle}>Socials:</p>
        <div className={styles.socials} aria-label="Social links">
          <a
            href="https://github.com/chasov-artem"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.iconLink}
            aria-label="GitHub profile"
          >
            <FaGithub className={styles.icon} />
          </a>
          <a
            href="https://linkedin.com/in/artem-chasov-504a351aa"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.iconLink}
            aria-label="LinkedIn profile"
          >
            <FaLinkedin className={styles.icon} />
          </a>
          <a
            href="https://t.me/chasovartem"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.iconLink}
            aria-label="Telegram"
          >
            <FaTelegramPlane className={styles.icon} />
          </a>
          <a
            href="https://www.instagram.com/be_real_awesome_instead"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.iconLink}
            aria-label="Instagram profile"
          >
            <FaInstagram className={styles.icon} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
